exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3nrJ-{display:flex;padding:0;cursor:pointer;transition-duration:.2s;transition-property:opacity;opacity:1;border:0;border-radius:0;outline:none;background-color:transparent;justify-content:center;align-items:center}._3nrJ-:hover{opacity:.7}._2bgT-{visibility:hidden !important;width:0 !important;min-width:0 !important;height:0 !important;min-height:0 !important;margin:0 !important;padding:0 !important;opacity:0 !important}._3KHOg{position:absolute;z-index:100;visibility:hidden;transition:opacity .2s, visibility .2s;opacity:0}._3KHOg._2M2xw{padding:4px 5px;background:rgba(0,0,0,0.5)}._3KHOg._14nbp{visibility:visible;opacity:1}._2M2xw ._1DbVJ{font-size:11px;line-height:12px;white-space:nowrap;color:white}\n", ""]);

// Exports
exports.locals = {
	"controlButton": "_3nrJ-",
	"hidden": "_2bgT-",
	"tooltip": "_3KHOg",
	"showAsText": "_2M2xw",
	"tooltipVisible": "_14nbp",
	"tooltipInner": "_1DbVJ"
};